<div class="app-header">
  <button class="hamburger-btn" (click)="toggleMenu()" [attr.aria-expanded]="!menuCollapsed"
    [attr.aria-label]="menuCollapsed ? 'Abrir menu' : 'Fechar menu'">
    <i class="material-icons">{{ menuCollapsed ? 'menu' : 'close' }}</i>
  </button>

  <organizacao-switcher></organizacao-switcher>

  <div class="header-right-content">
    <div class="user-profile" dropdown>
      <div class="user-info-trigger" dropdownToggle>
        <div class="user-avatar" [style.background-image]="avatarUrl">
          <span *ngIf="!avatarUrl">{{ getInitials(loggedUser?.name) }}</span>
        </div>
        <div class="user-details">
          <span class="user-name">{{ loggedUser?.name }}</span>
        </div>
        <i class="material-icons chevron">keyboard_arrow_down</i>
      </div>

      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right profile-menu">
        <li>
          <a class="profile-menu-item" [routerLink]="['/pages/minha-conta/minha-conta']">
            Minha Conta
          </a>
        </li>
        <li>
          <a class="profile-menu-item" [routerLink]="['/pages/minha-conta/vendedores']">
            Vendedores
          </a>
        </li>
        <li>
          <a class="profile-menu-item" [routerLink]="['/pages/minha-conta/meus-terminais']">
            Meus Terminais
          </a>
        </li>
        <li class="profile-menu-divider"></li>
        <li>
          <a class="profile-menu-item profile-menu-item--logout" (click)="logout()">
            Sair
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>